import React, { useState } from 'react';
import { FLAG_BASE } from '../config';

function flagUrl(cc: string): string {
  return `${FLAG_BASE}FLAG_${cc.toUpperCase()}.png`;
}

function Flag({ cc, height }: { cc: string; height: number }) {
  const [errored, setErrored] = useState(false);
  if (errored || !cc) {
    return (
      <span
        style={{
          fontSize: height * 0.7,
          fontWeight: 600,
          letterSpacing: '0.04em',
          color: 'var(--color-muted)',
          lineHeight: 1
        }}
      >
        {cc.toUpperCase()}
      </span>
    );
  }
  return (
    <img
      src={flagUrl(cc)}
      alt={`${cc.toUpperCase()} flag`}
      loading="lazy"
      decoding="async"
      onError={() => setErrored(true)}
      style={{
        height,
        width: 'auto',
        display: 'block',
        borderRadius: 2,
        boxShadow: '0 1px 2px rgba(0,0,0,0.4)'
      }}
    />
  );
}

/**
 * Renders the two flags for a bilateral pair. If only cc1 is provided
 * (contributor has no second country), renders a single flag.
 */
export function FlagPair({
  cc1,
  cc2,
  height = 18
}: {
  cc1: string;
  cc2?: string | null;
  height?: number;
}) {
  if (!cc2) {
    return <Flag cc={cc1} height={height} />;
  }
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6
      }}
      aria-label={`${cc1.toUpperCase()} and ${cc2.toUpperCase()} bilateral pair`}
    >
      <Flag cc={cc1} height={height} />
      <span
        aria-hidden="true"
        style={{
          color: 'var(--color-accent)',
          fontSize: height * 0.7,
          lineHeight: 1,
          opacity: 0.7
        }}
      >
        ·
      </span>
      <Flag cc={cc2} height={height} />
    </span>
  );
}
